import { CatButton } from '@blocks-react/components/Button';
import { Conditional } from '../../../common';
import { CatIconChevronUp } from '@blocks-react/components/Icons/ChevronUp';
import { CatIconChevronDown } from '@blocks-react/components/Icons/ChevronDown';

interface AssociatedDealerSearchResultExpanderProps {
  handleExpander: () => void;
  isExpanded: boolean;
  disabled: boolean;
}

export const AssociatedDealerSearchResultExpander = ({
  handleExpander,
  isExpanded,
  disabled,
}: AssociatedDealerSearchResultExpanderProps) => {
  const chevronUpIcon = (
    <CatIconChevronUp
      size="lg"
      data-testid="expander-icon-close"
      slot="before"
    />
  );
  const chevronDownIcon = (
    <CatIconChevronDown
      size="lg"
      data-testid="expander-icon-open"
      slot="before"
    />
  );

  return (
    <CatButton
      onClick={handleExpander}
      size="sm"
      variant="ghost"
      hideText
      disabled={disabled}
    >
      <Conditional test={isExpanded} fallback={chevronDownIcon}>
        {chevronUpIcon}
      </Conditional>
    </CatButton>
  );
};
